import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-CardThirdPartyServices'
const BUTTON_DESIGN = atomButtonDesigns.OUTLINE
const DEFAULT_BUTTON_COLOR = 'primary'
function ThirdPartyServicesContent({
  buttonIcon = null,
  handleButtonClick = () => {},
  isButton = true,
  thirdPartyInfo = {}
}) {
  const {
    bottomText,
    bottomTextImg,
    bottomTextImgGooglePay,
    buttonColor = DEFAULT_BUTTON_COLOR,
    buttonHref,
    buttonText,
    cardServiceIcon,
    customContent,
    image,
    imageText,
    text,
    title,
    titleImage
  } = thirdPartyInfo

  const hasImage = Boolean(image)
  const hasCardServiceIcon = Boolean(cardServiceIcon)
  const hasCustomContent = Boolean(customContent)
  const hasTitleImage = Boolean(titleImage)
  const hasBottomTextImg = Boolean(bottomTextImg)

  const buttonBottomText = cx(`${BASE_CLASS}-buttonBottomText`, {
    'has-not-image': !hasImage
  })
  const mainContainer = cx(`${BASE_CLASS}-mainContainer`, {
    'has-card-service-icon': hasCardServiceIcon,
    'has-custom-content': hasCustomContent,
    'has-image': hasImage,
    'has-title-image': hasTitleImage
  })
  const sectionClassName = cx(`${BASE_CLASS}-section`, {
    'has-card-service-icon': hasCardServiceIcon
  })

  return (
    <div className={mainContainer}>
      <div className={`${BASE_CLASS}-contentWrapper`}>
        <div className={`${BASE_CLASS}-content`}>
          <div className={`${BASE_CLASS}-title`}>
            <div className={`${BASE_CLASS}-titleWrapper`}>
              {title && <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={title} />}
              <p className={`${BASE_CLASS}-titleDescription`}>{text}</p>
            </div>
            {titleImage && <img className={`${BASE_CLASS}-titleImage`} src={titleImage} alt="" />}
          </div>
          <div className={sectionClassName}>
            {hasCustomContent && customContent}
            <div className={`${BASE_CLASS}-buttonWrapper`}>
              <AtomButton
                color={buttonColor}
                design={BUTTON_DESIGN}
                fullWidth
                href={buttonHref}
                leftIcon={buttonIcon}
                link={!isButton}
                onClick={handleButtonClick}
                rel="nofollow noopener"
                shape={atomButtonShapes.CIRCULAR}
                target="_blank"
              >
                {buttonText}
              </AtomButton>
              <div className={`${BASE_CLASS}-buttonBottomContent`}>
                <p className={buttonBottomText}>{bottomText}</p>
                {hasBottomTextImg && (
                  <>
                    <img
                      className={`${BASE_CLASS}-imageBottomTextGooglePay`}
                      src={bottomTextImgGooglePay}
                      alt="google pay"
                    />
                    <img className={`${BASE_CLASS}-imageBottomText`} src={bottomTextImg} alt="santander logo" />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {hasCardServiceIcon && (
          <div className={`${BASE_CLASS}-serviceIconWrapper`}>
            <img src={cardServiceIcon} alt="" />
          </div>
        )}
      </div>
      {image && (
        <div className={`${BASE_CLASS}-imageContainer`}>
          <img alt={bottomText} className={`${BASE_CLASS}-image`} src={image} />
          <span className={`${BASE_CLASS}-imageText`}>{imageText}</span>
        </div>
      )}
    </div>
  )
}

ThirdPartyServicesContent.displayName = 'ThirdPartyServicesContent'
ThirdPartyServicesContent.propTypes = {
  buttonIcon: PropTypes.node,
  handleButtonClick: PropTypes.func,
  isButton: PropTypes.bool,
  thirdPartyInfo: PropTypes.shape({
    bottomText: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonText: PropTypes.string,
    image: PropTypes.string,
    imageText: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string
  })
}

export default ThirdPartyServicesContent
